import React from "react";
import { useTranslation } from "react-i18next";
import { SpinnerLoader } from "@activecollab/components";
import PropTypes from "prop-types";

const LoadMorePagination = ({ title, isLoading, fetchMore }) => {
  const { t } = useTranslation();
  return (
    <div className="load_more_pagination">
      {isLoading ? (
        <span className="tw-flex tw-flex-row tw-items-center tw-text-theme-600">
          <SpinnerLoader className="tw-mr-1" />
          {t("Loading")} ...
        </span>
      ) : (
        <button
          onClick={fetchMore}
          className="tw-text-theme-600 tw-bg-transparent tw-border-0 tw-cursor-pointer tw-underline"
        >
          {title}
        </button>
      )}
    </div>
  );
};

LoadMorePagination.propTypes = {
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  fetchMore: PropTypes.func,
};

LoadMorePagination.defaultProps = {
  title: "",
  isLoading: false,
};

export default LoadMorePagination;
